import { render, staticRenderFns } from "./GeoDocentHistoryList.vue?vue&type=template&id=7437f3f3&scoped=true"
import script from "./GeoDocentHistoryList.vue?vue&type=script&lang=js"
export * from "./GeoDocentHistoryList.vue?vue&type=script&lang=js"
import style0 from "./GeoDocentHistoryList.vue?vue&type=style&index=0&id=7437f3f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7437f3f3",
  null
  
)

export default component.exports